import axios from "axios";

// ============= FUNNEL CRUD =============

export const getAllFunnels = (activeOnly = false) => async (dispatch) => {
  const res = await axios.get(`/api/funnels?activeOnly=${activeOnly}`);
  return res.data;
};

export const getFunnelById = (id) => async (dispatch) => {
  const res = await axios.get(`/api/funnels/${id}`);
  return res.data;
};

export const createFunnel = (funnelData) => async (dispatch) => {
  const res = await axios.post("/api/funnels", funnelData);
  return res.data;
};

export const updateFunnel = (id, funnelData) => async (dispatch) => {
  const res = await axios.put(`/api/funnels/${id}`, funnelData);
  return res.data;
};

export const deleteFunnel = (id) => async (dispatch) => {
  const res = await axios.delete(`/api/funnels/${id}`);
  return res.data;
};

export const reorderFunnels = (funnelIds) => async (dispatch) => {
  const res = await axios.put("/api/funnels/reorder", { funnelIds });
  return res.data;
};

export const seedDefaultFunnel = () => async (dispatch) => {
  const res = await axios.post("/api/funnels/seed");
  return res.data;
};

// ============= FUNNEL ANALYTICS =============

export const getAllFunnelsStats = (startDate, endDate) => async (dispatch) => {
  let url = "/api/analytics/funnels";
  const params = [];
  if (startDate) params.push(`startDate=${startDate}`);
  if (endDate) params.push(`endDate=${endDate}`);
  if (params.length > 0) url += `?${params.join("&")}`;

  const res = await axios.get(url);
  return res.data;
};

export const getFunnelStats = (funnelId, startDate, endDate) => async (dispatch) => {
  let url = funnelId ? `/api/analytics/funnel/${funnelId}` : "/api/analytics/funnel";
  const params = [];
  if (startDate) params.push(`startDate=${startDate}`);
  if (endDate) params.push(`endDate=${endDate}`);
  if (params.length > 0) url += `?${params.join("&")}`;

  const res = await axios.get(url);
  return res.data;
};

export const getRealTimeStats = (minutes = 30) => async (dispatch) => {
  const res = await axios.get(`/api/analytics/realtime?minutes=${minutes}`);
  return res.data;
};

export const getEngagementStats = (startDate, endDate) => async (dispatch) => {
  let url = "/api/analytics/engagement";
  const params = [];
  if (startDate) params.push(`startDate=${startDate}`);
  if (endDate) params.push(`endDate=${endDate}`);
  if (params.length > 0) url += `?${params.join("&")}`;
  const res = await axios.get(url);
  return res.data;
};

// eventType (optional): only visitors with that event (a funnel's entry stage)
export const getVisitorTrends = (startDate, endDate, eventType) => async (dispatch) => {
  let url = "/api/analytics/trends";
  const params = [];
  if (startDate) params.push(`startDate=${startDate}`);
  if (endDate) params.push(`endDate=${endDate}`);
  if (eventType) params.push(`eventType=${encodeURIComponent(eventType)}`);
  if (params.length > 0) url += `?${params.join("&")}`;

  const res = await axios.get(url);
  return res.data;
};

export const getReferrerStats = (startDate, endDate) => async (dispatch) => {
  let url = "/api/analytics/referrers";
  const params = [];
  if (startDate) params.push(`startDate=${startDate}`);
  if (endDate) params.push(`endDate=${endDate}`);
  if (params.length > 0) url += `?${params.join("&")}`;

  const res = await axios.get(url);
  return res.data;
};

export const getSearchKeywords = (startDate, endDate) => async (dispatch) => {
  let url = "/api/analytics/search-keywords";
  const params = [];
  if (startDate) params.push(`startDate=${startDate}`);
  if (endDate) params.push(`endDate=${endDate}`);
  if (params.length > 0) url += `?${params.join("&")}`;

  const res = await axios.get(url);
  return res.data;
};

// ============= CUSTOMER JOURNEY =============

// ============= FUNNEL STAGE MANAGEMENT =============

export const getFunnelStages = (funnelId, activeOnly = false) => async (dispatch) => {
  let url = funnelId
    ? `/api/funnels/${funnelId}/stages?activeOnly=${activeOnly}`
    : `/api/funnel-stages?activeOnly=${activeOnly}`;

  const res = await axios.get(url);
  return res.data;
};

export const createFunnelStage = (funnelId, stageData) => async (dispatch) => {
  const res = await axios.post(`/api/funnels/${funnelId}/stages`, stageData);
  return res.data;
};

export const updateFunnelStage = (id, stageData) => async (dispatch) => {
  const res = await axios.put(`/api/funnel-stages/${id}`, stageData);
  return res.data;
};

export const deleteFunnelStage = (id) => async (dispatch) => {
  const res = await axios.delete(`/api/funnel-stages/${id}`);
  return res.data;
};

export const reorderFunnelStages = (funnelId, stageIds) => async (dispatch) => {
  const res = await axios.put(`/api/funnels/${funnelId}/stages/reorder`, { stageIds });
  return res.data;
};
